/**
 * Get normalized data from spectra
 * @param spectra - Array of spectrum objects
 * @param options - Options for filtering spectra
 * @returns Normalized data with ids, matrix, meta, and x values
 */
export function getNormalizedData(spectra, options = {}) {
    const { ids } = options;
    const matrix = [];
    const meta = [];
    const currentIDs = [];
    let x = [];
    if (Array.isArray(spectra) && spectra.length > 0) {
        for (const spectrum of spectra) {
            if (!ids || ids.includes(spectrum.id)) {
                currentIDs.push(spectrum.id);
                matrix.push(spectrum.normalized.y);
                meta.push(spectrum.meta);
            }
        }
        x = spectra[0].normalized.x;
    }
    return { ids: currentIDs, matrix, meta, x };
}
//# sourceMappingURL=getNormalizedData.js.map